<button type="button" class="btn btn-primary round {{class}}" placement="bottom" container="body" [ngbTooltip]="'ui.edit-tooltip'|translate"
  (click)="onBtnClick($event)"><i class="far fa-edit"></i>
</button>
